import { TWO_FACTOR_AUTHENTICATION_DIALOG_ID } from "@obg/common.verification";
import { CORE_ROUTE } from "@obg/ngx.core";

export const LATEST_TC_DIALOG_ID = "LATEST_TC_DIALOG_ID";
export const UPDATED_TC_DIALOG_ID = "UPDATED_TC_DIALOG";
export const LOGIN_CONSENTS_DIALOG_ID = "login-consents";
export const SGA_LOGIN_DIALOG_ID = "SGA_LOGIN_DIALOG_CONTAINER";
export const SMART_ID_LOGIN_DIALOG_ID = "SMART_ID_LOGIN_DIALOG_CONTAINER";
export const SUSPICIOUS_LOGIN_DIALOG_ID = "suspicious-login";
export const NEW_SUSPICIOUS_LOGIN_DIALOG_ID = "new-suspicious-login";
export const MARKETING_CONSENT_RENEWAL_DIALOG_ID = "marketing-consent-renewal";
export const LOGIN_YEARLY_REVIEW_DIALOG_ID = "login-yearly-review";
export const MIGRATED_USER_WELCOME_DIALOG_ID = "migrated-customer-welcome";
export const MIGRATION_NOTIFICATION_DIALOG_ID = "migration-notification";
export const COMPLETE_ACCOUNT_LOGIN_DIALOG_ID = "COMPLETE_ACCOUNT_LOGIN_DIALOG_ID";
export const REQUEST_CPF_DIALOG_ID = "REQUEST_CPF_DIALOG";

export const ALL_FLOW_DIALOGS_IDS = [
	CORE_ROUTE.auth.login,
	CORE_ROUTE.auth.bankIdVerification,
	UPDATED_TC_DIALOG_ID,
	LATEST_TC_DIALOG_ID,
	LOGIN_CONSENTS_DIALOG_ID,
	SGA_LOGIN_DIALOG_ID,
	SMART_ID_LOGIN_DIALOG_ID,
	SUSPICIOUS_LOGIN_DIALOG_ID,
	NEW_SUSPICIOUS_LOGIN_DIALOG_ID,
	TWO_FACTOR_AUTHENTICATION_DIALOG_ID,
	MARKETING_CONSENT_RENEWAL_DIALOG_ID,
	LOGIN_YEARLY_REVIEW_DIALOG_ID,
	MIGRATED_USER_WELCOME_DIALOG_ID,
	MIGRATION_NOTIFICATION_DIALOG_ID,
	COMPLETE_ACCOUNT_LOGIN_DIALOG_ID,
	REQUEST_CPF_DIALOG_ID,
];
